import { render, staticRenderFns } from "./GoCard.vue?vue&type=template&id=053cd7cf&scoped=true"
import script from "./GoCard.vue?vue&type=script&lang=js"
export * from "./GoCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "053cd7cf",
  null
  
)

export default component.exports